import { Card } from "@mui/material";
import React from "react";

interface MultiCardStackProps {
  children: React.ReactNode;
  stackEnabled: boolean;
}

const topCardNudge = -4;
const leftCardNudge = -2;

export const MultiCardStack: React.FC<MultiCardStackProps> = ({
  children,
  stackEnabled,
}) => {
  return (
    <>
      {stackEnabled ? (
        <Card
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "visible",
            top: topCardNudge,
            left: leftCardNudge,
          }}
        >
          {children}
        </Card>
      ) : (
        children
      )}
    </>
  );
};
